import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { IClient } from '@pec/aion-ui-core/interfaces/client';

const name = 'clientsForScores';

export const fetchClientsForScores = createAsyncThunk(`${name}/fetch`, async (organizationId: string, { dispatch }) => {
  try {
    const { data } = await axios.get<IClient[]>(`/api/v2/organizations/${organizationId}/clients`);
    return data;
  } catch (error) {
    dispatch(enqueueRequestErrorSnackbar());
    throw error;
  }
});

export type State = CommonState & {
  clientsForScores: IClient[];
};

const initialState: State = {
  clientsForScores: [],
  isFetching: false,
  error: null
};

const clientsForScores = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchClientsForScores.pending, isFetching)
      .addCase(fetchClientsForScores.fulfilled, (state, action) => {
        state.clientsForScores = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchClientsForScores.rejected, error);
  }
});

export const { reducer: clientsForScoresReducer } = clientsForScores;
